<template>
    <line-chart :chart-data="dataCollection" :options="chartOptions" style="height: 150px;"></line-chart>
</template>

<script>
    import LineChart from "./LineChart";
    import dayjs from "dayjs"
    import dateTexts from "../../../data/dateTexts"
    import ChartFunctions from "@/components/portfolio/charts/ChartFunctions";
    import Portfolio from "@/lib/models/Portfolio";

    export default {
        name: "SimpleChart",
        props: ['portfolio'],
        components: {
            "line-chart": LineChart,
        },
        mixins: [
            ChartFunctions
        ],
        data() {
            return {
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    elements: {point: {radius: 1}},
                    layout: {
                        padding: {
                            top: 8,
                            bottom: 8
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                // precision:0
                            }
                        }],
                        xAxes: [{
                            display: false
                        }],
                    },
                    legend: {
                        display: false
                    }
                }
            }
        },
        computed: {
            dataCollection() {
                const dates = this.generateDates(this.portfolio);
                return {
                    labels: dates.map(m => m.text),
                    datasets: dates.length > 0 ? [
                        /*{
                            label: 'Invested',
                            borderColor: '#1F9BCF',
                            steppedLine: 'middle',
                            data: this.generateInvestments(this.portfolio, dates)
                        },*/
                        {
                            label: 'Profit',
                            borderColor: '#4BBF73',
                            borderWidth: 2,
                            data: this.generateProfits(this.generateInvestments(this.portfolio, dates), this.generatePriceInTimes(this.portfolio, dates))
                        }, /*{
                            label: 'Value',
                            borderColor: '#d9534f',
                            data: this.generatePriceInTimes(this.portfolio, dates)
                        }*/
                    ] : []
                }
            }
        },
        methods: {
            generateDates(portfolio) {
                const latestMove = portfolio.moves.sort((a, b) => a.date > b.date ? -1 : 1).slice(-1).pop();
                if (latestMove) {
                    const daysToPast = dayjs().diff(dayjs(latestMove.date), 'day');
                    const daySpace = Math.ceil(daysToPast / 10);
                    let day = dayjs().subtract(daysToPast, 'day').set('hour', 0).set('minute', 0).set('second', 0);
                    const dates = [];
                    for (let i = 0; i < daysToPast; (i += daySpace)) {
                        dates.push({
                            text: dayjs(day).format('YYYY-MM-DD'),
                            dateFrom: dayjs(day),
                            dateTo: dayjs(day).add(daySpace, 'day'),
                        });
                        day = day.add(daySpace, 'day')
                    }
                    return dates;
                } else {
                    return [];
                }

            }
        }
    }
</script>
